"use client";

import React, { useState, useEffect } from "react";
import "./Header.css";

const Header = () => {

  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    document.body.className = darkMode ? "dark" : "light";
  }, [darkMode]);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };

  return (
    <header className={`header ${scrolled ? "scrolled" : ""}`}>
      <div className="header-container">
        <div className="header-inner">
          {/* Hamburger Menu (mobile only) */}
          <button 
            className={`hamburger ${mobileMenuOpen ? "active" : ""}`}
            onClick={toggleMobileMenu}
            aria-label="Toggle mobile menu"
          >
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
          </button>

          {/* Logo */}
          <a href="/" className="brand">
            <span className="brand-name">InnoRock</span>
          </a>

          {/* Desktop Navigation */}
          <nav className="nav">
            <a href="#services" className="nav-link">Services</a>
            <a href="#about" className="nav-link">About</a>
            <a href="#contact" className="nav-link">Contact</a>
          </nav>

          {/* Mobile Dark Mode Toggle */}
          <button 
            className="header-theme-toggle"
            onClick={toggleDarkMode}
            aria-label="Toggle dark mode"
          >
            {darkMode ? "☀️" : "🌙"}
          </button>
        </div>

        {/* Mobile Navigation Menu - Dropdown */}
        <div className={`mobile-nav ${mobileMenuOpen ? "active" : ""}`}>
          <a href="#services" className="mobile-nav-link" onClick={closeMobileMenu}>
            Services
          </a>
          <a href="#about" className="mobile-nav-link" onClick={closeMobileMenu}>
            About
          </a>
          <a href="#contact" className="mobile-nav-link" onClick={closeMobileMenu}>
            Contact
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;       // so: import Header from "./components/Header"
export { Header };          // optional named export if you prefer
